import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBarRef,
} from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ResourcesService } from '../../resources.service';

@Component({
    selector: 'app-download-email-snackbar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './download-email-snackbar.component.html',
    styleUrls: ['./download-email-snackbar.component.scss'],
    standalone: false
})
export class DownloadEmailSnackbarComponent implements OnInit, OnDestroy {
  strUrl: string;
  totalLength: number = 0;
  mailPopup: boolean = false;
  mailSentSuccess: boolean = false;
  downloadSuccess: boolean = false;
  email = new FormControl('', [Validators.required, Validators.email]);
  @ViewChild('popover') popover: ElementRef;
  baseSiteId: any;
  baseSub: Subscription;
  routerSub: Subscription;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) private data: any,
    private readonly _snackRef: MatSnackBarRef<DownloadEmailSnackbarComponent>,
    private readonly cd: ChangeDetectorRef,
    private readonly resourcesService: ResourcesService,
    private readonly router: Router,
    private readonly baseSiteService: BaseSiteService
  ) {}

  ngOnInit(): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._snackRef.dismiss();
      }
    });
    if (this.data?.selectedDocUrlList?.length > 0) {
      this.data?.selectedDocUrlList;
      this.strUrl = '';
      this.totalLength = this.data.selectedDocUrlList.length;
      this.data.selectedDocUrlList.forEach((element, index) => {
        if (index <= this.data.selectedDocUrlList.length - 1) {
          this.strUrl = this.strUrl + `window.open('${element}');`;
        }
      });
      this.cd.detectChanges();
    } else {
      this._snackRef.dismiss();
    }
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.routerSub?.unsubscribe();
  }
  closeEmailDownloadPopover() {
    this.mailPopup = false;
  }

  downloadPDF() {
    this.data.selectedDocUrlList.forEach((element, index) => {
      window.open(element);
      if (index === this.data.selectedDocUrlList.length - 1) {
        this.mailPopup = false;
        this.mailSentSuccess = false;
        this.downloadSuccess = true;
        let that = this;
        setInterval(function () {
          that.downloadSuccess = false;
        }, 3000);
      }
    });
  }

  detectChanges() {
    this.downloadSuccess = false;
    this.cd.detectChanges();
  }

  openEmailDownloadPopover() {
    this.mailPopup = true;
    this.mailSentSuccess = false;
    this.downloadSuccess = false;
  }

  mailSelectedDocs() {
    const filterBySelected = this.data.docList.filter(
      (doc) => doc.selected === true
    );
    const selectedDocsArr = [];
    filterBySelected.forEach((element) => {
      const obj = {
        isSelected: element['selected'],
        documentUrl: element['file']['location'],
        documentMimeType: element['file']['mimeType'],
        documentFileName: element['file']['realFileName'],
      };
      selectedDocsArr.push(obj);
    });
    const params = {
      documents: selectedDocsArr,
      toEmail: this.email.value,
    };
    this.resourcesService.mailDocuments(params).subscribe((res) => {
      this.mailPopup = false;
      this.mailSentSuccess = true;
      this.downloadSuccess = false;
      setTimeout(() => {
        this.mailSentSuccess = false;
      }, 3000);
    });
  }
}
